import { render, staticRenderFns } from "./hisimfo.vue?vue&type=template&id=1b87ab92&scoped=true&"
import script from "./hisimfo.vue?vue&type=script&lang=js&"
export * from "./hisimfo.vue?vue&type=script&lang=js&"
import style0 from "./hisimfo.vue?vue&type=style&index=0&id=1b87ab92&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b87ab92",
  null
  
)

export default component.exports